import { Storage } from '@ionic/storage-angular'; 
import { ApiService } from '../services/api/api.service';
import { ROUTES } from '../services/api/api.constants';
import { Injectable } from '@angular/core';
import { UserParams, User } from '../models/User';
import { NgxSpinnerService } from 'ngx-spinner';
import { Lesson } from '../models/Lesson';
import { Sesion } from '../models/Sesion';
import { Routine } from '../models/Routine';
import { Round } from '../models/Round';
import { SmsMessageGroup } from '../models/SmsMessageGroup';

export interface SmsMessageGroupParams {
  id_sucursal: number;
  nombre:string;
  page:number;
  id_gimnasio:number;
}

@Injectable({
  providedIn: 'root'
})

/**
  * SmsMessageGroup provider
  * CRUD Y FILTROS
  */
export class SmsMessageGroupProvider {  
  constructor(
    private api: ApiService,
    private storage: Storage,
    private spinner: NgxSpinnerService,
  ) {
  }


  /**
    * @author Sergio Castro
    * @description Obtiene la lista de grupos para sms
    * @date 31 Mayo 2021
    * @param params filtros para obtener grupos como (id_gimnasio,id_sucursal,nombre,page)
    * @return grupos
    * @exceptions lista de errores en petición de api
   */
  public async getSmsMessageGroups(params: Partial< SmsMessageGroupParams>){
    this.spinner.show();
    let base = ROUTES.sms_groups.index
    if (params.page) base += `?page=${params.page}`; 
    if (!params.page) base += `?page=${1}`; 
    if (params.nombre) base += `&q=${params.nombre}`; 
    if (params.id_gimnasio) base += `&id_gimnasio=${params.id_gimnasio}`; 
    if (params.id_sucursal) base += `&id_sucursal=${params.id_sucursal}`; 
    

    
    let SmsMessageGroup = (await this.api.get(base));


    if(SmsMessageGroup.data){
    }

    this.spinner.hide();

    return SmsMessageGroup;
  }

  /**
    * @author Sergio Castro
    * @description crea un registro de grupo para sms
    * @date 31 Mayo 2021
    * @param smsMessageGroup
    * @return grupo
    * @exceptions lista de errores en petición de api
   */
  public async createSmsGroups(smsMessageGroup: SmsMessageGroup){

    this.spinner.show();
    let base = ROUTES.sms_groups.store

    let atls = [];
    smsMessageGroup.atletas.forEach(element => {
      atls.push(element.id);
    });
    let fCreate = new Date();
    let data = {nombre:smsMessageGroup.nombre,id_sucursal:smsMessageGroup.id_sucursal,id_gimnasio:smsMessageGroup.id_gimnasio,atletas:JSON.stringify(atls),fecha_creacion:this.formatFecha(fCreate)}

    let smsMessageGroups = (await this.api.post(base,data));


    if(smsMessageGroups.data){
      
      smsMessageGroups.data = new SmsMessageGroup(smsMessageGroups.data);
    }

    this.spinner.hide();

    return smsMessageGroups;
  }
  /**
    * @author Sergio Castro
    * @description Obtiene un grupo de sms
    * @date 31 Mayo 2021
    * @param id
    * @return grupo sms
    * @exceptions lista de errores en petición de api
   */
  public async getSmsMessageGroup(id:number){

    this.spinner.show();
    let base = ROUTES.sms_groups.show(id)

    let smsMessageGroup = (await this.api.get(base));

    if(smsMessageGroup.data){
      
      smsMessageGroup.data = new SmsMessageGroup( smsMessageGroup.data);
    }

    this.spinner.hide();

    return smsMessageGroup;
  }

  /**
    * @author Sergio Castro
    * @description elimina un grupo sms
    * @date 31 Mayo 2021
    * @param id
    * @return grupo sms
    * @exceptions lista de errores en petición de api
   */
  public async deleteSmsMessageGroup(id:number){

    this.spinner.show();
    let base = ROUTES.sms_groups.destroy(id)

    let emailGroups = (await this.api.delete(base));

    this.spinner.hide();

    return emailGroups;
  }
  
  /**
  * @author Sergio Castro
  * @description Obtiene la fecha en formato yyyy-mm-dd
  * @date 26 diciembre 2020
  * @param fecha
  * @return fecha
  */
 formatFecha(fecha){
  let mes = fecha.getMonth()+1;
  let dia = fecha.getDate();
  return fecha.getFullYear()+'-'+(mes < 10 ? '0'+mes:mes)+'-'+(dia < 10 ? '0'+dia:dia);
}
  
/**
    * @author Sergio Castro
    * @description Actualiza un grupo sms
    * @date 31 Mayo 2021
    * @param smsMessageGroup
    * @return grupo sms
    * @exceptions lista de errores en petición de api
   */
public async updateSmsMessageGroup(smsMessageGroup: SmsMessageGroup){

  this.spinner.show();
  let base = ROUTES.sms_groups.update(smsMessageGroup.id)

  let atls = [];
  smsMessageGroup.atletas.forEach(element => {
    atls.push(element.id);
  });
  let data = {nombre:smsMessageGroup.nombre,id_sucursal:smsMessageGroup.id_sucursal,id_gimnasio:smsMessageGroup.id_gimnasio,atletas:JSON.stringify(atls)}
  let smsMessageGroups = (await this.api.put(base,data));


  if(smsMessageGroups.data){
    
    smsMessageGroups.data = new SmsMessageGroup(smsMessageGroups.data);
  }

  this.spinner.hide();

  return smsMessageGroups;
}

}